import {translations} from '../../../../environments/translations.ru';
import {Columns} from "compob2b-table";

export const DAM_SHARE_FORM: Columns[] = [
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: false,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
    width: '10%',
  },
  {
    key: 'startDate',
    title: translations.startDate,
    placeholder: translations.startDate,
    searchEnabled: false,
    formly: true,
    grid: true,
    type: 'date',
    defaultValue: new Date(),
  },
  {
    key: 'endDate',
    title: translations.endDate,
    placeholder: translations.endDate,
    searchEnabled: false,
    formly: true,
    grid: true,
    type: 'date',
    defaultValue: new Date(),
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    grid: true,
    defaultValue: true,
    width: '10%',
    type: 'checkbox',
    required: true
  },
  {
      key: 'action',
      title: translations.action,
      placeholder: translations.action,
      searchEnabled: false,
      orderEnabled: false,
      grid: true,
      width: '20%',
      type: 'input',
      required: true
  }
];
